import React from 'react'
import PropTypes from 'prop-types'
import { isString, isEqual, pick } from 'lodash'
import { Box, Button, TextField } from '@material-ui/core'

class RangeFilterMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      from: this.processValue(props.from),
      to: this.processValue(props.to),
    }
  }
  componentDidUpdate(prevProps) {
    const watchedFields = ['from', 'to']
    if (!isEqual(pick(prevProps, watchedFields), pick(this.props, watchedFields))) {
      this.setState({
        from: this.processValue(this.props.from),
        to: this.processValue(this.props.to),
      })
    }
  }
  apply() {
    this.props.onApply(this.state.from, this.state.to)
  }
  clear() {
    this.props.onApply()
  }
  handleChange(name, value) {
    this.setState({ [name]: this.processValue(value) })
  }
  processValue(value) {
    if (isString(value)) {
      return this.noZeroStart(value)
    }
    if (value === undefined) {
      return ''
    }
    return value
  }
  noNonNumericCharacters(e) {
    if (e.target.value.length === 1 && e.target.value.match(/(\.|e|E|-|\+)+/g)) {
      e.preventDefault()
    }
  }
  noZeroStart(value) {
    value = value.replace(/[^\d]/g, '')
    if (value.length > 1) {
      return value.replace(/^0+/g, '')
    }
    return value
  }
  render() {
    return (
      <Box
        component="form"
        padding={2}
        onSubmit={() => this.apply()}
        maxWidth="285px"
        width="100%"
      >
        <TextField
          name="range-filter-menu-from"
          id="range-filter-menu-from-id"
          fullWidth
          variant="outlined"
          color="primary"
          margin="normal"
          type="number"
          label="At least"
          value={this.state.from}
          inputProps={{ min: 1, max: this.state.to }}
          onChange={(e) => {
            this.noNonNumericCharacters(e)
            this.handleChange('from', e.target.value)
          }}
          autoFocus
        />
        <TextField
          fullWidth
          name="range-filter-menu-to"
          id="range-filter-menu-to-id"
          variant="outlined"
          color="primary"
          margin="normal"
          type="number"
          label="Up To"
          value={this.state.to}
          inputProps={{ min: this.state.from || 0 }}
          onChange={(e) => {
            this.noNonNumericCharacters(e)
            this.handleChange('to', e.target.value)
          }}
        />
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          gridGap={8}
          mt={2}
        >
          <Button
            color="primary"
            variant="outlined"
            onClick={() => this.clear()}
          >
            Clear
          </Button>
          <Button
            type="submit"
            disabled={parseInt(this.state.from) > parseInt(this.state.to)}
            color="primary"
            variant="contained"
          >
            Apply
          </Button>
        </Box>
      </Box>
    )
  }
}

RangeFilterMenu.propTypes = {
  from: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onApply: PropTypes.func.isRequired,
}

export default RangeFilterMenu
